import { JwtAxios } from '@/packaging';

export const errorReportAPI = {
  // 오류 보고 접수 (백엔드 ErrorReport/Submit, AllowAnonymous)
  // payload: { errorType, program, userId, problemUrl, message, detail }
  async submit(payload) {
    const res = await JwtAxios.post('/ErrorReport/Submit', payload);
    return res;
  }
};
